import { TranslocoDirective, TranslocoPipe, provideTranslocoScope, translate } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DeliveryDestinationNote, DeliveryDestinations } from '../../../../interfaces/deliveryDestionations.model';
import { CustomersEditAddressDetailsDialogComponent } from '../customers-edit-address-details-dialog-component/customers-edit-address-details-dialog-component';

@Component({
  providers: [provideTranslocoScope('customers')],
  selector: 'cus-customers-address-details-dialog-component',
  imports: [TranslocoPipe,
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    TranslocoDirective,
  ],
  templateUrl: './customers-address-details-dialog-component.html',
  styleUrl: './customers-address-details-dialog-component.scss',
})
export class CustomersAddressDetailsDialogComponent {
  readonly mainFields = [
    { get label() { return translate<string>('customers.ui.riferimento'); }, key: 'riferimento' },
    { get label() { return translate<string>('customers.ui.citta'); }, key: 'citta' },
    { get label() { return translate<string>('customers.ui.cap'); }, key: 'cap' },
    { get label() { return translate<string>('customers.ui.indirizzo'); }, key: 'indirizzo' },
  ] as const;

  readonly noteFields: { label: string; key: keyof DeliveryDestinationNote }[] = [
    { get label() { return translate<string>('customers.ui.notaLibera'); }, key: 'notaLibera' },
    { get label() { return translate<string>('customers.ui.orari'); }, key: 'orari' },
    { get label() { return translate<string>('customers.ui.contatto'); }, key: 'contatto' },
    { get label() { return translate<string>('customers.ui.sponda'); }, key: 'sponda' },
  ] as const;

  private editAddressDetailsDialogRef?: MatDialogRef<CustomersEditAddressDetailsDialogComponent>;

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CustomersAddressDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: DeliveryDestinations,
  ) {}

  onClose() {
    this.dialogRef.close();
  }

  onReset() {
    this.dialogRef.close({ action: 'reset' });
  }

  onApply() {
    this.dialogRef.close({ action: 'apply' });
  }

  openEditDialog() {
    if (this.editAddressDetailsDialogRef) {
      return;
    }

    this.editAddressDetailsDialogRef = this.dialog.open(CustomersEditAddressDetailsDialogComponent, {
      data: this.data,
    });
    this.editAddressDetailsDialogRef.afterClosed().subscribe(value => {
      this.editAddressDetailsDialogRef = undefined;

      if (value) {
        this.dialogRef.close({ action: 'edit', destination: this.data, value });
      }
    });
  }
}
